import { Styled_scale_props } from '@assets/types/Styled_scale_props'

//calculate scaled size for current screen relative to scale provided to component and sizes object
export const scaled = (prop: string) => ({ scale, sizes, mobile }: Styled_scale_props) => sizes[prop][mobile] ? (`${(scale * sizes[prop][mobile]).toFixed(2)}px`) : ''